<template>
  <div class="mk">
    <!-- CATEGORIAS -->
    <nav class="mk-cats" aria-label="Categorías">
      <div class="mk-rail">
        <button type="button" class="mk-chip" :class="{ on: !cat }" :aria-pressed="!cat ? 'true' : 'false'" @click="pickCat('')">
          <v-icon small>mdi-view-grid-outline</v-icon> Todo <span class="mk-n">{{ baseStores.length }}</span>
        </button>
        <button v-for="c in chips" :key="c.name" type="button" class="mk-chip" :class="{ on: cat === c.name }" :aria-pressed="cat === c.name ? 'true' : 'false'" @click="pickCat(c.name)">
          <v-icon small>{{ c.icon }}</v-icon> {{ c.name }} <span class="mk-n">{{ c.count }}</span>
        </button>
      </div>
    </nav>

    <main class="mk-main">
      <!-- DESTACADO -->
      <section v-if="featured" class="mk-hero" aria-label="Destacado">
        <router-link :to="storeLink(featured)" class="mk-hero-link" :aria-label="`Ir a ${featured.attributes.name}`">
          <img class="mk-hero-img" :src="cover(featured)" alt="" fetchpriority="high">
          <span class="mk-hero-shade"></span>
          <span class="mk-hero-tag">Hoy en Festy</span>
          <span class="mk-hero-text">
            <span class="mk-hero-name">{{ featured.attributes.name }}</span>
            <span class="mk-hero-kind">{{ kind(featured) }}</span>
          </span>
        </router-link>
        <div v-if="stores.length > 1" class="mk-hero-ctl">
          <button v-for="(s, i) in stores" :key="s.id" type="button" class="mk-dot" :class="{ on: i === featIndex }" :aria-label="`Ver ${s.attributes.name}`" @click="feat = i"></button>
          <button type="button" class="mk-arrow" aria-label="Anterior" @click="feat = featIndex - 1"><v-icon small dark>mdi-chevron-left</v-icon></button>
          <button type="button" class="mk-arrow gold" aria-label="Siguiente" @click="feat = featIndex + 1"><v-icon small>mdi-chevron-right</v-icon></button>
        </div>
      </section>

      <!-- COMERCIOS -->
      <section class="mk-sec">
        <div class="mk-sec-head">
          <h2>Elige un comercio</h2>
          <span class="mk-count" aria-live="polite">{{ countLabel }}</span>
        </div>

        <div v-if="$store.state.loading && !$store.state.loadError" class="mk-grid" aria-busy="true" aria-label="Cargando comercios">
          <div v-for="n in 3" :key="n" class="mk-card mk-skel">
            <div class="mk-pulse" style="height:130px"></div>
            <div class="mk-card-body">
              <div class="mk-pulse" style="height:22px;width:60%"></div>
              <div class="mk-pulse" style="height:14px;width:40%"></div>
              <div class="mk-pulse" style="height:52px"></div>
              <div class="mk-pulse" style="height:52px"></div>
            </div>
          </div>
        </div>

        <div v-else-if="$store.state.loadError" class="mk-box err" role="alert">
          <h3>No pudimos cargar los comercios</h3>
          <p>Revisa tu conexión e inténtalo de nuevo.</p>
          <button type="button" class="mk-btn" @click="reload">Reintentar</button>
        </div>

        <div v-else-if="stores.length === 0" class="mk-box">
          <h3>No encontramos comercios</h3>
          <p>Prueba con otra categoría o borra la búsqueda.</p>
          <button type="button" class="mk-btn" @click="pickCat('')">Ver todos</button>
        </div>

        <div v-else class="mk-grid">
          <article v-for="s in stores" :key="s.id" class="mk-card">
            <div class="mk-cover">
              <img :src="cover(s)" alt="" loading="lazy" decoding="async">
              <span v-if="kind(s)" class="mk-badge">{{ kind(s) }}</span>
            </div>
            <div class="mk-card-body">
              <div class="mk-logo-row">
                <img v-if="s.attributes.logoUrl" class="mk-logo" :src="s.attributes.logoUrl" :alt="`Logo de ${s.attributes.name}`" loading="lazy">
                <span v-else class="mk-logo mono" aria-hidden="true">{{ s.attributes.name.charAt(0) }}</span>
              </div>
              <div>
                <h3 class="mk-name">{{ s.attributes.name }}</h3>
                <p class="mk-sub">{{ s.attributes.subtitle || kind(s) }}</p>
              </div>
              <div class="mk-dishes">
                <div v-for="d in dishes(s)" :key="d.id" class="mk-dish">
                  <img :src="d.attributes.imageUrl" alt="" loading="lazy" decoding="async">
                  <div class="mk-dish-t">
                    <div class="mk-dish-n">{{ d.attributes.name }}</div>
                    <div class="mk-dish-p">{{ (d.attributes.newPrice ? d.attributes.newPrice : d.attributes.price) | currency }}</div>
                  </div>
                  <button type="button" class="mk-add" :aria-label="`Agregar ${d.attributes.name}`" @click="openDialogAddItem(d)">+</button>
                </div>
              </div>
              <router-link :to="storeLink(s)" class="mk-more">
                Ver menú completo <v-icon small color="#c91d20">mdi-arrow-right</v-icon>
              </router-link>
            </div>
          </article>
        </div>
      </section>

      <!-- SE ANTOJA HOY -->
      <section v-if="hot.length" class="mk-sec" aria-label="Platos de hoy">
        <div class="mk-sec-head"><h2>Se antoja hoy</h2><span class="mk-count">Platos de todos los comercios</span></div>
        <div class="mk-strip">
          <article v-for="p in hot" :key="p.id" class="mk-hot">
            <img :src="p.attributes.imageUrl" alt="" loading="lazy" decoding="async">
            <div class="mk-hot-b">
              <div>
                <div class="mk-dish-n">{{ p.attributes.name }}</div>
                <div class="mk-hot-s">{{ p.attributes.store && p.attributes.store.attributes ? p.attributes.store.attributes.name : '' }}</div>
              </div>
              <div class="mk-hot-f">
                <strong>{{ (p.attributes.newPrice ? p.attributes.newPrice : p.attributes.price) | currency }}</strong>
                <button type="button" class="mk-add gold" :aria-label="`Agregar ${p.attributes.name}`" @click="openDialogAddItem(p)">+</button>
              </div>
            </div>
          </article>
        </div>
      </section>

      <!-- FESTY BOT -->
      <section class="mk-sec">
        <div class="mk-bot">
          <span class="mk-eyebrow">Festy Bot</span>
          <h2>¿Prefieres escribir? Pide por chat a cualquier comercio.</h2>
          <p>Dile qué se te antoja. El bot arma tu pedido con los precios reales y lo envía al comercio.</p>
          <button type="button" class="mk-btn gold" @click="openBot">Abrir el chat</button>
        </div>
      </section>

      <!-- PARA COMERCIOS -->
      <section class="mk-sec last">
        <a class="mk-biz" href="https://negocios.festyapp.co">
          <span class="mk-eyebrow dark">Para comercios</span>
          <span class="mk-biz-t">¿Vendes productos? Crea tu tienda en línea.</span>
          <span class="mk-biz-c">Registrar mi comercio</span>
        </a>
      </section>
    </main>

    <!-- BARRA DEL PEDIDO -->
    <div v-if="cartInfo.count > 0" class="mk-cartbar-wrap" role="status">
      <div class="mk-cartbar">
        <div class="mk-cartbar-t">
          <div class="mk-cartbar-n">{{ cartInfo.storeName }}</div>
          <div class="mk-cartbar-d">{{ cartInfo.count }} {{ cartInfo.count === 1 ? 'producto' : 'productos' }}</div>
        </div>
        <strong class="mk-cartbar-p">{{ cartInfo.total | currency }}</strong>
        <button type="button" class="mk-cartbar-b" :aria-label="`Pedir en ${cartInfo.storeName}`" @click="openCart">Pedir</button>
      </div>
    </div>

    <v-dialog
      v-model="dialogAddItems"
      max-width="600"
      scrollable
      v-if="promotion"
      :no-click-animation="true"
    >
      <v-card class="mx-auto">

        <v-card-title class="subtitle-1 d-inline-block text-truncate pb-1">
          <v-btn class="float-right" icon @click="dialogAddItems = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          {{ promotion.attributes.name }}
        </v-card-title>

         <v-card-subtitle class="subtitle-2 pb-1">
          {{ promotion.attributes.store.attributes.name }}
        </v-card-subtitle>

        <v-img
          aspect-ratio="1.7778"
          v-if="promotion.attributes.imageUrl"
          :lazy="promotion.attributes.imageUrl"
          :src="promotion.attributes.imageUrl"
          position="center"
        ></v-img>

        <v-card-text>
          <v-row>
            <v-col cols=12>
              <div class="headline"> {{ promotion.attributes.newPrice ? promotion.attributes.newPrice : promotion.attributes.price | currency }} </div>
              <div class="subtitle-2"> DOMICILIO: {{ promotion.attributes.deliveryCost | currency }} </div>
            </v-col>
             <v-col cols="12" class="pt-0 pb-0">
              <p class="body-2 black--text mb-1" v-if="!descriptionComplete">
                {{promotion.attributes.description.slice(0, 120)}}
                <span v-if="promotion.attributes.description.length > 120">....</span>
                <a @click="readMore()" v-if="promotion.attributes.description.length > 120"> Ver más</a>
              </p>
              <p class="body-2 black--text mb-1" v-else>
                    {{promotion.attributes.description}}
                    <a @click="readMore()"> Ver menos</a>
              </p>
            </v-col>

            <v-col cols="12" class="pt-0 pb-0" v-if="promotion.attributes.modifiers && promotion.attributes.modifiers.length > 0">
                <v-row>
                  <v-col cols="12" v-for="(item, index) in promotion.attributes.modifiers" :key="index" class="pt-1 pb-1">
                    <div class="body-1"> <strong>{{ item.title }}</strong> <span class="caption info--text font-weight-bold">{{ item.mandatory ? '(obligatorio)' : '' }}</span> </div>
                    <div class="body-1 ma-0 pa-0" v-if="!item.multiple">
                      <v-radio-group v-model="itemsBox[item.title]" hide-details class="pa-1 ma-0" row>
                        <v-radio
                          v-for="(option, index2) in item.options" :key="index2"
                          :label="`${option.label}`"
                          :value="option"
                          @change="setModifiersMirrorBox(item, option)"
                        >
                         <template v-slot:label>
                          {{ option.label }} <strong class="ml-2 caption font-weight-bold"> {{ option.price > 0 ? '+' + $options.filters.currency(option.price) : ''}}</strong>
                        </template>
                        </v-radio>
                      </v-radio-group>
                      </div>
                      <div class="body-1 ma-0 pa-0" justify="space-around" v-else>
                      <v-checkbox
                          class="ma-1"
                          v-for="(option, index2) in item.options" :key="index2"
                          v-model="itemsCheck"
                          hide-details
                          :value="option"
                          @change="setModifiersMirrorCheck(item)"
                        >
                        <template v-slot:label>
                          {{ option.label }} <strong class="ml-2 caption font-weight-bold"> +{{ option.price > 0 ? option.price : 0 | currency}}</strong>
                        </template>
                        </v-checkbox>
                    </div>
                  </v-col>
                </v-row>
            </v-col>

            
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn tile small color="grey" icon @click="removeQuantity()" :disabled="quantity <= 1">
            <v-icon color="grey darken-3">mdi-minus-circle-outline</v-icon>
          </v-btn>

          <div class="pr-2 pl-2"><strong>{{ quantity }}</strong></div>

          <v-btn tile small color="grey" icon @click="addQuantity()">
            <v-icon color="success">mdi-plus-circle-outline</v-icon>
          </v-btn>

          <v-btn
            color="success darken-1"
            @click="addPromoToCar()"
          >
            <v-icon>mdi-cart-plus</v-icon>
            <span class="ml-2 font-weight-bold d-flex d-md-none">Agregar</span>
            <span class="ml-2 font-weight-bold d-none d-md-flex">Agregar {{ quantity * (promotion.attributes.newPrice ? promotion.attributes.newPrice : promotion.attributes.price + selectModifiers.reduce((a, b) => { return a + b.options.reduce((c, d) => { return c + d.price}, 0) }, 0) ) | currency }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Parse from 'parse'

const ICONS = [
  [/pizza/, 'mdi-pizza'], [/sushi|japon|asiat|wok/, 'mdi-fish'], [/mediterr|pasta|marisc|italian/, 'mdi-pasta'],
  [/parrilla|carne|asado|bbq/, 'mdi-grill'], [/hamburg/, 'mdi-hamburger'], [/postre|helad|pastel|panader/, 'mdi-cupcake'],
  [/bebida|licor|cerveza|jugo|caf/, 'mdi-cup'], [/super|market|tienda/, 'mdi-cart-outline'], [/farmac|salud/, 'mdi-pill']
]

const ORDER = ['pizza', 'sushi', 'mediterránea', 'mediterranea', 'parrilla']
const rank = (n) => { const i = ORDER.indexOf(String(n).toLowerCase()); return i < 0 ? 99 : i }

export default {
  data() {
    return {
      cat: '',
      feat: 0,
      dialogAddItems: false,
      promotion: '',
      quantity: 1,
      modifiers: '',
      comboOption: '',
      comboPrice: '',
      selectModifiers: [],
      itemsBox: [],
      itemsCheck: [],
      descriptionComplete: false,
    };
  },

  computed: {
    baseStores() {
      return (this.$store.state.promos || []).filter(s => s.attributes.topProducts && s.attributes.topProducts.length > 0)
    },
    stores() {
      return this.cat ? this.baseStores.filter(s => this.kind(s) === this.cat) : this.baseStores
    },
    chips() {
      const names = (this.$store.state.categories || []).filter(n => n && n !== 'Todas').sort((a, b) => rank(a) - rank(b) || a.localeCompare(b))
      return names.map(name => {
        const hit = ICONS.find(([re]) => re.test(name.toLowerCase()))
        return { name, icon: hit ? hit[1] : 'mdi-storefront-outline', count: this.baseStores.filter(s => this.kind(s) === name).length }
      })
    },
    featIndex() {
      const n = this.stores.length
      return n ? ((this.feat % n) + n) % n : 0
    },
    featured() {
      return this.stores[this.featIndex] || null
    },
    hot() {
      return (this.$store.state.hotPromos || []).filter(p => p.attributes && p.attributes.imageUrl).slice(0, 12)
    },
    countLabel() {
      if (this.$store.state.loading) return ''
      const n = this.stores.length
      return n === 1 ? '1 comercio' : n + ' comercios'
    },
    cartInfo() {
      const cart = this.$store.state.cart || []
      let count = 0, total = 0
      cart.forEach(i => { count += i.quantity; total += (i.price + (i.modifiersPrice || 0)) * i.quantity })
      return { count, total, storeName: cart.length ? cart[0].storeName : '' }
    }
  },

  mounted() {
    this.$store.state.searchStoreBox = true
  },

  beforeDestroy() {
    this.$store.state.searchStoreBox = false
  },

  methods: {
    pickCat(name) {
      this.cat = name
      this.feat = 0
    },

    kind(s) {
      const c = s.attributes.storeCategory
      return c && c.attributes ? c.attributes.name : ''
    },

    cover(s) {
      const a = s.attributes
      if (a.coverUrl) return a.coverUrl
      if (a.bannerUrl) return a.bannerUrl
      const p = (a.topProducts || []).find(x => x.attributes && x.attributes.imageUrl)
      return p ? p.attributes.imageUrl : ''
    },

    storeLink(s) {
      return `/store/${s.attributes.slug ? s.attributes.slug : s.id}`
    },

    dishes(s) {
      return (s.attributes.topProducts || []).filter(p => p.attributes && p.attributes.imageUrl).slice(0, 2)
    },

    reload() {
      window.location.reload()
    },

    openBot() {
      window.dispatchEvent(new CustomEvent('festy-bot-open'))
    },

    openCart() {
      if (!Parse.User.current()) {
        this.$router.push('/login')
        return
      }
      this.$store.state.cartModelNavigation = true
    },

    openDialogAddItem(promo){
      //eslint-disable-next-line
      this.promotion = ''
      this.promotion = promo
      this.quantity = 1
      this.modifiers = ''
      this.comboOption = ''
      this.comboPrice = ''
      this.dialogAddItems = true
      this.selectModifiers = []
      this.itemsCheck = []
      this.itemsBox = []
    },

    addQuantity(){
      this.quantity = this.quantity+1
    },

    removeQuantity(){
      if (this.quantity > 1) {
        this.quantity = this.quantity-1
      }
    },

    addPromoToCar(){

      if(!Parse.User.current()){
         this.$router.push('/login')
         return;
      }

      if (!window.localStorage){
        this.$snotify.error('Su navegador no soporta el almacenamiento local.' , 'LocalStorage', {
          timeout: 4000,
          preventDuplicates: true
        });
        return;
      }

      if (this.$store.state.cart && this.$store.state.cart.length > 0) {
        if (this.$store.state.cart[0].store !== this.promotion.attributes.store.id) {
          this.$swal('Multiples comercios', `Ya tienes productos de ${this.$store.state.cart[0].storeName} en el carrito de compras, primero debes finalizar tu pedido con ellos para agregar productos de otro comercio.`, 'info');
          return;
        } 
      }

      if (this.promotion.attributes.modifiers && this.promotion.attributes.modifiers.length > 0) {
        let self = this
        let cleanOptions = this.promotion.attributes.modifiers.filter((o1) => {
          if(o1.mandatory){
            return !self.selectModifiers || self.selectModifiers.length <= 0 || !self.selectModifiers.find((element) => o1.title === element.title )
          }
        }, self);

        if (cleanOptions.length > 0) {
          this.$snotify.html(`<div class="snotifyToast__title"><b>Modificadores</b></div><div class="snotifyToast__body">Seleccione los modificadores <strong>${cleanOptions.map(u => u.title).join(', ')}</strong> del producto para poder agregarlo al carrito</div><div class="snotify-icon snotify-icon--info"></div>`, {
            timeout: 7000,
            preventDuplicates: true,
            type: 'info'
          });
          return;
        }
      
      }
      
      
      let cartItem = {
        product: this.promotion.id,
        quantity: this.quantity,
        price: this.promotion.attributes.newPrice ? this.promotion.attributes.newPrice : this.promotion.attributes.price,
        name: this.promotion.attributes.name,
        withCombo: false, //this.comboOption
        comboPrice: this.promotion.attributes.comboPrice,
        comboNotes: this.promotion.attributes.comboNotes,
        store: this.promotion.attributes.store.id,
        storeName: this.promotion.attributes.store.attributes.name,
        minAmount: this.promotion.attributes.store.attributes.minAmount,
        logoUrl: this.promotion.attributes.store.attributes.logoUrl,
        imageUrl: this.promotion.attributes.imageUrl,
        description: '',
        modifiers: this.selectModifiers,
        modifiersText: this.modifiersDetails(this.selectModifiers, false),
        modifiersPrice: this.selectModifiers.reduce((a, b) => { return a + b.options.reduce((c, d) => { return c + d.price}, 0) }, 0),
        deliveryCost: this.promotion.attributes.deliveryCost,
        fee: this.promotion.attributes.store.attributes.fee
      }
      
      this.$store.commit("pushCart", cartItem);
      window.localStorage.setItem("cartFestyApp", JSON.stringify(this.$store.state.cart));
      window.localStorage.setItem("paymentFestyApp", JSON.stringify(this.promotion.attributes.store.attributes.payment));
      
      if (this.promotion.attributes.store.attributes.acceptBankTransfer && this.promotion.attributes.store.attributes.transfersMethods.length > 0) {
        window.localStorage.setItem("storePaymentsMethodsFestyApp", JSON.stringify(this.promotion.attributes.store.attributes.transfersMethods));
      }else{
        window.localStorage.setItem("storePaymentsMethodsFestyApp", JSON.stringify([]));
      }

      if (this.promotion.attributes.store.attributes.hasCardReader) {
        window.localStorage.setItem("storePaymentsHasCardReader", 1);
      }else{
        window.localStorage.setItem("storePaymentsHasCardReader", '');
      }

      this.dialogAddItems = false
    },
    
    getPedidoTextDatails(items, slice_text){
      let pedido_array = []
      if (items) {
        items.forEach((item, index) => {
          pedido_array.push({
            name: `(${item.attributes.quantity}) - ${item.attributes.name} - (${this.$options.filters.currency(item.attributes.price)} c/u) ${item.attributes.comboOption ? ' + (' + this.$options.filters.currency(item.attributes.comboPrice) + ')' : ''}`,
            modifiers: item.attributes.modifiers ? item.attributes.modifiers.length > 0 ? this.modifiersDetails(item.attributes.modifiers, slice_text) : '' : '',
            end: index+1 < items.length ? false : true
          })
        });
        return pedido_array
      }
    },

    modifiersDetails(modifiers, slice_text){
      let pedido_text = ''
      let pedido_text_temp = ''
      modifiers.forEach((item, indx) => {
        if (item.options) {
          item.options.forEach((option, index) => {
            pedido_text += `${option.label}`
            if (index+1 < item.options.length) {            
              pedido_text += ' | '
            }
          })

          if (indx+1 < modifiers.length) {            
              pedido_text += ' | '
            }
        }
      })

      pedido_text_temp = pedido_text

      if (slice_text) {
        pedido_text_temp = pedido_text.substring(0, 150)
        if (pedido_text.length > 150) {
          pedido_text_temp += '....'
        }
      }

      return pedido_text_temp
    },

    setModifiersMirrorCheck(item){
      //eslint-disable-next-line
      //console.log(this.itemsCheck);

      var cleanOptions = item.options.filter((word) => this.itemsCheck.includes(word));
      //console.log(cleanOptions);

      if (cleanOptions.length <= 0) {
        let index = this.selectModifiers.findIndex((element) => item.title === element.title )
        this.selectModifiers.splice(index, 1)
        return;
      }

      let newItem = {
        mandatory: item.mandatory,
        multiple: item.multiple,
        options: cleanOptions,
        title: item.title
      }
      let checkItem = this.selectModifiers.find((element) => item.title === element.title )
      if (checkItem) {
        let index = this.selectModifiers.findIndex((element) => item.title === element.title )
        this.selectModifiers[index] = newItem
      }else{
        this.selectModifiers.push(newItem) 
      }

      //eslint-disable-next-line
      //console.log(this.selectModifiers);
    },

    setModifiersMirrorBox(item, option){
      
      let newItem = {
        mandatory: item.mandatory,
        multiple: item.multiple,
        options: [option],
        title: item.title
      }
      let checkItem = this.selectModifiers.find((element) => item.title === element.title )
      if (checkItem) {
        let index = this.selectModifiers.findIndex((element) => item.title === element.title )
        this.selectModifiers[index] = newItem
      }else{
        this.selectModifiers.push(newItem) 
      }

      //eslint-disable-next-line
      //console.log(this.selectModifiers);
    },

    getBreakPointCol(){
      switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 2
          case 'sm': return 3
          case 'md': return 3
          case 'lg': return 3
          case 'xl': return 3
        }
    },

    readMore(){
      this.descriptionComplete = !this.descriptionComplete
    },
  }
};
</script>

<style lang="css">
.mk { --ink:#17150E; --gray:#625E4E; --line:#E3E0D2; --bg:#F6F5EF; --red:#c91d20; --gold:#F3D923;
  background: var(--bg); color: var(--ink); font-family: 'Onest', 'Roboto', system-ui, sans-serif; min-height: 100%; padding-bottom: 96px; }
.mk h2, .mk h3, .mk .mk-name, .mk .mk-hero-name { font-family: 'Bricolage Grotesque', 'Onest', sans-serif; }
.mk button { font-family: inherit; cursor: pointer; }
.mk button:focus-visible, .mk a:focus-visible { outline: 2px solid var(--red); outline-offset: 2px; }
.mk img { display: block; }

/* categorias */
.mk-cats { position: sticky; top: 56px; z-index: 4; background: #fff; border-bottom: 1px solid var(--line); }
.mk-rail { display: flex; gap: 8px; overflow-x: auto; padding: 10px 16px; scrollbar-width: none; max-width: 1280px; margin: 0 auto; }
.mk-rail::-webkit-scrollbar { display: none; }
.mk-chip { flex: none; display: inline-flex; align-items: center; gap: 6px; min-height: 44px; padding: 0 14px; border-radius: 999px;
  border: 1px solid var(--line); background: #fff; color: var(--ink); font-size: 14px; font-weight: 600; transition: background-color .15s ease; }
.mk-chip .v-icon { color: inherit !important; }
.mk-chip.on { background: var(--ink); border-color: var(--ink); color: #fff; }
.mk-n { min-width: 22px; height: 22px; padding: 0 6px; box-sizing: border-box; border-radius: 999px; font-size: 12px; font-weight: 700; display: inline-grid; place-items: center; background: var(--bg); color: var(--gray); }
.mk-chip.on .mk-n { background: var(--gold); color: var(--ink); }

.mk-main { max-width: 1280px; margin: 0 auto; }

/* destacado */
.mk-hero { position: relative; padding: 12px 16px 0; }
.mk-hero-link { position: relative; display: block; height: 168px; border-radius: 22px; overflow: hidden; background: var(--ink); text-decoration: none; color: #fff !important; }
.mk-hero-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.mk-hero-shade { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(23,21,14,.05) 30%, rgba(23,21,14,.85) 100%); }
.mk-hero-tag { position: absolute; top: 14px; left: 14px; background: var(--gold); color: var(--ink); font-weight: 700; font-size: 11px; letter-spacing: .06em; text-transform: uppercase; padding: 5px 11px; border-radius: 999px; }
.mk-hero-text { position: absolute; left: 18px; right: 110px; bottom: 16px; display: flex; flex-direction: column; }
.mk-hero-name { font-weight: 750; font-size: 26px; line-height: 1; letter-spacing: -.03em; }
.mk-hero-kind { margin-top: 6px; font-size: 14px; color: #E9E6D8; }
.mk-hero-ctl { position: absolute; right: 30px; bottom: 14px; display: flex; align-items: center; gap: 8px; }
.mk-dot { width: 10px; height: 10px; border: 0; padding: 0; border-radius: 999px; background: rgba(255,255,255,.55); transition: width .25s ease; display: none; }
.mk-dot.on { width: 28px; background: var(--gold); }
.mk-arrow { width: 44px; height: 44px; border-radius: 50%; border: 1px solid rgba(255,255,255,.5); background: rgba(23,21,14,.45); display: grid; place-items: center; }
.mk-arrow.gold { background: var(--gold); border: 0; }

/* secciones */
.mk-sec { padding: 24px 16px 8px; }
.mk-sec.last { padding-bottom: 32px; }
.mk-sec-head { display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.mk-sec-head h2 { margin: 0; font-weight: 750; font-size: 26px; letter-spacing: -.03em; line-height: 1.1; }
.mk-count { font-size: 13px; color: var(--gray); }
.mk-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(min(320px, 100%), 1fr)); gap: 18px; }

/* tarjeta */
.mk-card { position: relative; background: #fff; border: 1px solid var(--line); border-radius: 24px; overflow: hidden; }
.mk-cover { position: relative; height: 110px; background: var(--ink); overflow: hidden; }
.mk-cover img { width: 100%; height: 100%; object-fit: cover; }
.mk-badge { position: absolute; top: 12px; left: 12px; background: rgba(255,255,255,.94); font-weight: 600; font-size: 12px; padding: 4px 10px; border-radius: 999px; }
.mk-card-body { padding: 0 16px 16px; display: flex; flex-direction: column; gap: 12px; }
.mk-logo-row { position: relative; z-index: 1; margin-top: -26px; display: flex; }
.mk-logo { width: 56px; height: 56px; border-radius: 50%; object-fit: contain; background: #fff; border: 3px solid #fff; box-shadow: 0 0 0 1px var(--line); }
.mk-logo.mono { display: grid !important; place-items: center; background: var(--ink); color: var(--gold); font-family: 'Bricolage Grotesque', sans-serif; font-weight: 800; font-size: 22px; }
.mk-name { margin: 0; font-weight: 700; font-size: 21px; letter-spacing: -.02em; line-height: 1.15; }
.mk-sub { margin: 2px 0 0; font-size: 13px; color: var(--gray); }
.mk-dishes { display: flex; flex-direction: column; gap: 10px; border-top: 1px solid #EFEDE2; padding-top: 12px; }
.mk-dish { display: flex; align-items: center; gap: 12px; }
.mk-dish img { width: 48px; height: 48px; border-radius: 12px; object-fit: cover; flex: none; }
.mk-dish-t { flex: 1; min-width: 0; }
.mk-dish-n { font-size: 15px; font-weight: 600; line-height: 1.25; }
.mk-dish-p { font-size: 13px; color: var(--gray); }
.mk-add { position: relative; z-index: 2; flex: none; width: 44px; height: 44px; border-radius: 50%; border: 1px solid var(--ink); background: #fff; color: var(--ink); font-size: 22px; line-height: 1; }
.mk-add.gold { background: var(--gold); border: 0; }
.mk-more { display: flex; align-items: center; justify-content: space-between; min-height: 44px; color: var(--red) !important; font-weight: 700; text-decoration: none; }
.mk-more::after { content: ""; position: absolute; inset: 0; }

/* se antoja */
.mk-strip { display: flex; gap: 12px; overflow-x: auto; padding-bottom: 8px; scrollbar-width: none; }
.mk-strip::-webkit-scrollbar { display: none; }
.mk-hot { flex: none; width: 190px; background: #fff; border: 1px solid var(--line); border-radius: 20px; overflow: hidden; }
.mk-hot img { width: 100%; height: 130px; object-fit: cover; }
.mk-hot-b { padding: 12px 14px 14px; display: flex; flex-direction: column; gap: 8px; }
.mk-hot-s { font-size: 12px; color: var(--gray); }
.mk-hot-f { display: flex; align-items: center; justify-content: space-between; }

/* bot y comercios */
.mk-bot { background: var(--ink); color: #fff; border-radius: 24px; padding: 24px; display: flex; flex-direction: column; gap: 12px; }
.mk-bot h2 { margin: 0; font-weight: 750; font-size: 28px; line-height: 1.05; letter-spacing: -.03em; text-wrap: balance; }
.mk-bot p { margin: 0; color: #B4B09C; font-size: 15px; }
.mk-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; color: var(--gold); }
.mk-eyebrow.dark { color: var(--ink); }
.mk-biz { display: flex; flex-direction: column; gap: 10px; text-decoration: none; color: var(--ink) !important; border: 2px dashed #B4B09C; border-radius: 24px; padding: 22px; background: #FBF1A3; }
.mk-biz-t { font-family: 'Bricolage Grotesque', sans-serif; font-weight: 750; font-size: 24px; line-height: 1.1; letter-spacing: -.03em; }
.mk-biz-c { align-self: flex-start; background: var(--ink); color: #fff; font-weight: 600; padding: 12px 16px; border-radius: 999px; }
.mk-btn { align-self: flex-start; min-height: 48px; padding: 0 20px; border-radius: 999px; border: 0; background: var(--ink); color: #fff; font-weight: 700; }
.mk-btn.gold { background: var(--gold); color: var(--ink); }
.mk-box { background: #fff; border: 1px dashed #B4B09C; border-radius: 20px; padding: 32px 20px; text-align: center; }
.mk-box.err { border: 1px solid var(--red); }
.mk-box h3 { margin: 0 0 8px; font-size: 20px; }
.mk-box p { margin: 0 0 16px; color: var(--gray); font-size: 14px; }
.mk-box .mk-btn { align-self: auto; }

/* barra del pedido */
.mk-cartbar-wrap { position: fixed; left: 0; right: 0; bottom: 68px; z-index: 6; display: flex; justify-content: center; padding: 0 12px; pointer-events: none; }
.mk-cartbar { pointer-events: auto; width: 100%; max-width: 640px; box-sizing: border-box; background: var(--ink); color: #fff; border-radius: 20px; padding: 8px 8px 8px 18px; display: flex; align-items: center; gap: 12px; box-shadow: 0 20px 40px -14px rgba(23,21,14,.6); animation: mk-up .3s ease both; }
.mk-cartbar-t { flex: 1; min-width: 0; line-height: 1.25; }
.mk-cartbar-n { font-weight: 700; font-size: 15px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mk-cartbar-d { font-size: 12px; color: #B4B09C; }
.mk-cartbar-p { font-family: 'Bricolage Grotesque', sans-serif; font-size: 18px; }
.mk-cartbar-b { border: 0; background: var(--gold); color: var(--ink); font-weight: 700; padding: 0 18px; min-height: 44px; border-radius: 12px; }

.mk-pulse { background: #EFEDE2; border-radius: 10px; animation: mk-pulse 1.2s ease-in-out infinite; }
.mk-skel .mk-card-body { padding-top: 16px; }
@keyframes mk-pulse { 50% { opacity: .5; } }
@keyframes mk-up { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .mk * { animation: none !important; transition: none !important; } }

@media (min-width: 600px) {
  .mk-cats { top: 64px; }
}
@media (min-width: 960px) {
  .mk-rail { padding: 12px 32px; }
  .mk-chip { font-size: 15px; padding: 0 16px; }
  .mk-hero { padding: 24px 32px 0; }
  .mk-hero-link { height: 380px; border-radius: 28px; }
  .mk-hero-name { font-size: 48px; }
  .mk-hero-kind { font-size: 17px; }
  .mk-hero-text { left: 28px; bottom: 26px; }
  .mk-hero-ctl { right: 28px; bottom: 24px; gap: 12px; }
  .mk-dot { display: block; }
  .mk-hero-tag { top: 20px; left: 20px; font-size: 12px; padding: 6px 12px; }
  .mk-sec { padding: 36px 32px 8px; }
  .mk-sec-head h2 { font-size: 34px; }
  .mk-grid { gap: 24px; }
  .mk-cover { height: 150px; }
  .mk-bot { flex-direction: row; flex-wrap: wrap; align-items: center; padding: 40px; border-radius: 32px; }
  .mk-bot > * { flex: 1 1 100%; }
  .mk-bot h2 { font-size: 38px; max-width: 640px; }
  .mk-bot p { max-width: 460px; }
  .mk-hot { width: 236px; }
  .mk-hot img { height: 170px; }
  .mk-cartbar-wrap { bottom: 64px; }
}
</style>
